<template>
  <div class="page box-card">
    <div class="box-card-content">
      <div class="item web">
        <div class="left">
          <div class="text">Web Trader Platform</div>
        </div>
        <div class="right">
          <div class="desc">
            Access customisable workspaces, and advanced charts with our award-winning browser-based <br>trading platform.
          </div>

          <div class="reset-query query">
            <el-form :inline="true">
              <el-form-item label="Choose Market">
                <el-select v-model="market">
                  <el-option label="US Stock Daytrade" value="US Stock Daytrade"></el-option>
                </el-select>
              </el-form-item>
            </el-form>
          </div>

          <div class="btn kg-btn2">
            Start Trading
          </div>

        </div>
      </div>
      <div class="item app">
        <div class="left">
          <div class="text">Mobile trading apps</div>
        </div>
        <div class="right">
          <div class="desc">
            ASeize trading opportunities with simple one-swipe trading, advanced charting, and seamless <br> execution.
          </div>

          <div class="down-android">
            Android Phone
          </div>

          <a class="btn kg-btn2" :href="file.file">
            Downloads
          </a>

        </div>
      </div>
    </div>
  </div>
</template>

<script>

import { mapState } from 'vuex'
export default {
  name: 'record',
  data () {
    return {
      market: '',
      file: {}
    }
  },
  created () {
    this.getRecord()
  },
  methods: {
    getRecord () {
      // this.$http.post('/web/public/website/websiteApp').then(result => {
      //   this.file = result.data || {}
      // })
    }
  },
  computed: {
    ...mapState(['userInfo'])
  },
  components: {

  }
}
</script>
<style scoped lang="scss">
.page {

  text-align: left;

  .box-card-content {
    background: url('../../../assets/img/user/personal-bg.png') no-repeat center / 100% 100%;
    width: 1220px;
    min-height: 600px;
    padding-top: 40px;
    padding-left: 65px;
    padding-right: 80px;
    padding-bottom: 30px;
    margin: 50px auto;

    .item {
      display: flex;
      padding: 50px 0;

      &:first-child {
        border-bottom: 1px solid rgb(#FFFFFF, 0.2);
      }

      .left {
        flex: 0 0 300px;

        &::before {
          content: '';
          width: 123px;
          height: 123px;
          display: block;
          margin: 0 auto;
        }

        .text {
          font-size: 18px;
          font-family: Arial;
          font-weight: bold;
          color: #01B2F5;
          line-height: 51px;
          text-align: center;
        }
      }

      .right {
        flex: 1;

        .desc {
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 24px;
        }

        .btn {
          width: 130px;
          margin-left: -10px;
        }
      }

      &.web {
        .left {
          &::before {
            background: url('../../../assets/img/web.png') no-repeat center / 100% auto;
          }
        }

        .reset-query {
          margin-top: 20px;
        }
      }

      &.app {
        .left {
          &::before {
            background: url('../../../assets/img/yidn.png') no-repeat center / 100% auto;
          }
        }

        .down-android {
          margin-top: 15px;
          margin-bottom: 15px;
          font-size: 16px;
          font-family: Arial;
          font-weight: 400;
          color: #FFFFFF;
          line-height: 51px;
          display: flex;
          align-items: center;
          margin-left: -10px;

          &::before {
            content: '';
            display: block;
            width: 46px;
            height: 48px;
            margin-right: 10px;
            background: url('../../../assets/img/icon-android.png') no-repeat center / 100% 100%;
          }
        }
      }
    }

  }

  .no-data {
    font-size: 16px;
    color: #fff;
    padding-top: 100px;
  }
}

@media only screen and (max-width: 755px) {
  .page {

    .box-card-content {}
  }
}
</style>
